





























































































































import { Vue, Component, Prop, Ref, Watch, Provide } from 'vue-property-decorator'
import {Getter, Mutation} from "vuex-class";
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {FormRowWings, InputWings, TextareaWings} from 'wings-ui-components';
import { MsgTransports } from '@/store/types';
import { CustomTemplateItemImpl } from '@/store/templates/types';
import { Route } from 'vue-router';
import {cloneDeep} from "lodash";
import { removeItem } from '@/utils/data-helper';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericTemplate, FormRowWings, InputWings, TextareaWings}})
export default class CustomTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate!: GenericTemplate;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private transport = MsgTransports.CUSTOM;
  private templateObject = new CustomTemplateItemImpl();
  private selectedCustomParameters = [];

  created() {
    this.setTemplate()
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }

  get atLeastOneIsFull(): boolean {
    let result: boolean = !!this.template.image
      || !!this.template.buttonName
      || !!this.template.buttonLink;
    return result;
  }

  // Из vue-material.md-table
  onSelect(items: any) {
    this.selectedCustomParameters = items;
  }

  // Добавить строку в таблицу
  addEmptyCustomParameter(): void {
    if (this.template.custom_parameters === undefined) {
      this.template.custom_parameters = [];
    }
    this.template.custom_parameters.push({name: undefined, value: undefined});
  }

  // Удаление строки/строк из таблицы
  deleteselectedCustomParameters(): void {
    if (this.template.custom_parameters) {
      this.selectedCustomParameters.forEach((rule: any) =>
        removeItem(this.template.custom_parameters, rule));
      if (this.template.custom_parameters.length === 0) {
        this.addEmptyCustomParameter();
      }
    }
  }
}
